var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContrast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7676 10.5C23.9751 10.5 19.2676 15.2075 19.2676 21C19.2676 26.7925 23.9751 31.5 29.7676 31.5C35.5601 31.5 40.2676 26.7925 40.2676 21C40.2676 15.2075 35.5601 10.5 29.7676 10.5ZM8.76758 14C4.90008 14 1.76758 17.1325 1.76758 21C1.76758 24.8675 4.90008 28 8.76758 28C12.6351 28 15.7676 24.8675 15.7676 21C15.7676 17.1325 12.6351 14 8.76758 14ZM8.76758 24.5C6.84258 24.5 5.26758 22.925 5.26758 21C5.26758 19.075 6.84258 17.5 8.76758 17.5C10.6926 17.5 12.2676 19.075 12.2676 21C12.2676 22.925 10.6926 24.5 8.76758 24.5Z",
    fill: "#A8A7CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrast);
export default __webpack_public_path__ + "static/media/contrast.83a087890d88316b8da3d718cee08a4f.svg";
export { ForwardRef as ReactComponent };